module.exports = __webpack_public_path__ + "static/media/honeycombPeople3.dadf62ba.png";